import { api } from "../api/api";
import { ApiResponse } from "../models/base/ApiResponse";
import { UpdateSeoMetadataDTO } from "../models/seoMetadata/seoMetadata.request";
import { SeoMetadataSettingsDTO } from "../models/seoMetadata/seoMetadata.response";

export const seoMetadataService = {
	async GetSettingsByLocalId(localId: string): Promise<ApiResponse<SeoMetadataSettingsDTO>> {
		const { data } = await api.get<ApiResponse<SeoMetadataSettingsDTO>>(`/locals/${localId}/seoMetadata`);
		return data;
	},

	async UpdateForLocal(localId: string, dto: UpdateSeoMetadataDTO): Promise<ApiResponse<string>> {
		console.log("Updating SEO Metadata for localId:", localId, "with DTO:", dto);
		const { data } = await api.put<ApiResponse<string>>(`/locals/${localId}/seoMetadata`, dto);
		return data;
	},
};
